import React from 'react'
import Link from 'gatsby-theme-kn/src/components/atoms/Link'

const SidebarNewsModule = ({ news }) => {
  return (
    <div className="sidebar-module">
      <div className="sidebar-module-container">
        <h4>News</h4>
        <ul className="list-unstyled">
          {news.map((n, index) => (
            <li key={index}>
              <Link className="sidebar-link" link={`/${n.full_slug}`}>
                <span className="sidebar-link-title">{n.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default SidebarNewsModule
